// src/modules/roles/role.config.ts
import * as Yup from 'yup';
import { FormFieldConfig} from '../../types/formField.types'; 
import { roleApi } from '../../api/accountsApi'; 
import { createdByField, updatedByField, statusField } from '../../utils/formFields';
import { getFormFields, getInitialValues, getTableColumns, getValidationSchema } from '../../utils/fieldConfigHelpers';
import { CreateRoleRequest, Role, UpdateRoleRequest } from '../../types/roles.types';

// Field configuration for roles
export const roleFieldConfig: FormFieldConfig[] = [
  {
    name: 'name',
    label: 'Role Name',
    type: 'text',
    yup: Yup.string().required('Role Name is required'), 
    getInitialValue: (data) => data?.name || '',
    table: { minWidth: 150 },
    example: 'Admin',
  },
  {
    name: 'key',
    label: 'Role Key',
    type: 'text',
    yup: Yup.string().required('Role Key is required'), 
    getInitialValue: (data) => data?.key || '',
    table: { minWidth: 150 },
    example: 'admin_key',
  },
  statusField(), 
  //createdByField(),
  updatedByField(),
];
 
export const roleFormFields = getFormFields(roleFieldConfig); // ✅ Form Fields 
export const roleFormSchema = getValidationSchema(roleFieldConfig); // ✅ Yup Validation Schema 
export const roleFormInitialValues = (data: any):any => getInitialValues(roleFieldConfig, data); // ✅ Initial Values  

export const roleTableColumns = getTableColumns(roleFieldConfig); // ✅ Table Columns
// ✅ API config + metadata
export const roleConfig = {
    entityName: 'Role',
    redirectPath: '/accounts/roles',
    roleTableColumns, // ✅ include it here
    api:roleApi,
};

